import { Feature, Offer } from '@wwt/entities/search-response'

import { sortFeatures } from './sortFeatures.ts'

export const extractFeaturesFromOffer = (
	offer: Offer | undefined | null,
	count?: number,
	options: {
		hotel: boolean
		room: boolean
	} = {
		hotel: true,
		room: true
	},
	filterFunction: (feature: Feature) => boolean = () => true,
	optionPrioritySorting = true
): Feature[] => {
	if (!offer) {
		return []
	}

	const allFeatures: Feature[] = Array.prototype.concat(
		options.hotel ? (offer.hotelDynamic.checkInFeatures ?? []) : [],
		options.hotel ? (offer.hotelStatic.includedFeatures ?? []) : [],
		options.room ? (offer.roomDynamic.bookablePackagedFeatures ?? []) : [],
		options.room ? (offer.roomDynamic.bookableNotPackagedFeatures ?? []) : [],
		options.room ? (offer.roomDynamic.checkInFeatures ?? []) : [],
		options.room ? (offer.roomStatic.includedFeatures ?? []) : [],
		options.room ? (offer.roomDynamic.includedFeatures ?? []) : []
	)

	const filteredFeatures = allFeatures.filter(filterFunction)

	return sortFeatures(filteredFeatures, optionPrioritySorting, count)
}
